import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface Props {
  isSelected?: boolean;
  onClick: () => void;
  children: ReactNode;
}
const HospitalFilter = ({ children, isSelected, onClick }: Props) => {
  return (
    <Wrapper type="button" isSelected={isSelected} onClick={onClick}>
      {children}
    </Wrapper>
  );
};

export default HospitalFilter;

const Wrapper = styled.button<{ isSelected?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 14px;
  height: 36px;
  border-radius: 40px;
  & > * + * {
    margin-left: 2px;
  }
  ${({ theme, isSelected }) =>
    isSelected
      ? css`
          ${theme.typography.UI14R}
          color: ${theme.color.primary700};
          background-color: ${theme.color.primary100};
          border: 1px solid ${theme.color.primary600};
        `
      : css`
          ${theme.typography.UI14R}
          color: ${theme.color.gray700};
          background-color: ${theme.color.gray30};
          border: 1px solid ${theme.color.gray30};
        `}
`;
